<template>
  <!-- Main Layout -->
  <div
    class="main-layout m-4 ml-0 rounded-xl w-full"
    :class="[aditionalClasses, mainLayoutScrollClass, bgColor ? `bg-${bgColor}` : 'bg-background-normal', { 'flex flex-col': fillContent }]"
    :style="{ 
      'scrollbar-gutter': useStableScrollGutter ? 'stable' : 'auto' 
    }"
    @scroll="$emit('scroll')"
  >
    <div
      v-if="!noToolbar"
      :class="scrollToolbar ? 'main-layout--toolbar-scroll' : 'main-layout--toolbar'"
    >
      <slot name="toolbar" />
    </div>

    <slot name="filter" />

    <div
      class="main-layout--content"
      :class="[bgColor ? `bg-${bgColor}` : 'bg-background-normal', noContentPadding ? '' : 'px-4 pt-4', noBottomContentPadding ? '' : 'pb-4', { 'flex-1': fillContent }]"
    >
      <slot name="content" />
    </div>
    <BriefModeBanner v-if="getIsInspoMode" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BriefModeBanner from '../components/briefs/BriefModeBanner.vue'

export default {
  name: 'MainLayout',
  components: { BriefModeBanner },
  props: {
    aditionalClasses: {
      type: String,
      default: ''
    },
    scrollToolbar: {
      type: Boolean,
      default: false
    },
    // Skip rendering the toolbar strip entirely (no border/blur bar)
    noToolbar: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: null
    },
    noContentPadding: {
      type: Boolean,
      default: false
    },
    noBottomContentPadding: {
      type: Boolean,
      default: false
    },
    // Stretch the content area to fill the remaining layout height
    fillContent: {
      type: Boolean,
      default: false
    },
    mainLayoutScrollClass: {
      type: String,
      default: 'overflow-y-auto'
    },
    useStableScrollGutter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('BriefsModule', ['getIsInspoMode']),
    isRoutePublic () {
      return ['BoardsPublicView', 'DiscoveryExpertPublicView', 'DiscoveryExpertBoardPublicView'].includes(this.$route.name)
    }
  }
}
</script>

<style scoped lang="sass">
.main-layout
  max-height: calc(100vh - 32px)

  &--toolbar
    z-index: 49999
    background: rgba(255, 255, 255, 0.92)
    backdrop-filter: blur(12px)

    @apply border-b border-border-normal sticky top-0

  &--toolbar-scroll
    z-index: 49999
    @apply bg-white border-gray-300 shadow-sm

  &--content
    animation: fade 200ms ease-in-out
    @apply rounded-b-xl
</style>
